export const CRM_CUSTOMER_LIST = 'CRM_CUSTOMER_LIST';
export const CRM_CUSTOMER_DETAIL = 'CRM_CUSTOMER_DETAIL';
export const CRM_CUSTOMER_OPTION = 'CRM_CUSTOMER_OPTION';

export const CRM_SALES_ORDER_LIST = 'CRM_SALES_ORDER_LIST';
